import styled from "@emotion/styled";
export const Container = styled.section({
    minHeight: "7.6rem",
    width: "100%",
});
//# sourceMappingURL=Container.js.map